<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar title="購買記錄" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px;"
        />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <!-- ✅ 1) 首次載入 / 請求中：list 為空時顯示「載入中」，不要顯示 empty -->
        <div v-if="list.length === 0">
          <div v-if="isFetching || isFirstLoading" class="loading-box">
            <van-loading type="spinner" size="24px" />
            <div class="loading-text">{{ loadingText }}</div>
          </div>

          <van-empty v-else description="資料為空" />
        </div>

        <!-- ✅ 有資料才渲染列表 -->
        <div v-else>
          <div class="item_list" v-for="(v, key) in list" :key="key">
            <div class="lottery_info">
              <van-image class="cover" :src="v.ico">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="period-number">{{ v.expect }}</span>
              <span class="period-number">{{ v.name }}</span>
            </div>

            <!-- ✅ 1) 未開獎/未結算：不顯示「認證結果」整段，避免卡片歪 -->
            <div class="recent" v-if="v.opened">
              <div class="kuaisan-ball left">
                <div>
                  <span>認證結果</span>
                  <span class="ressquareBox">{{ v.size }}</span>
                  <span class="ressquareBox">{{ v.double }}</span>
                </div>
              </div>
            </div>

            <!-- ✅ 投注分开显示：類型 + 對應積分 -->
            <div class="recent">
              <div class="kuaisan-ball left">
                <div>
                  <span>投注</span>
                  <span
                    class="ressquareBox"
                    v-for="(citem, idx) in (v.data || [])"
                    :key="citem.id || idx"
                  >
                    {{ calcSize(citem.type) }} {{ formatPoints(getBetMoney(v, citem, idx)) }}積分
                  </span>
                </div>
              </div>
            </div>

            <div class="topInfo">
              <span v-if="v.status === 1" style="color: #07c160">{{ v.status_text }}</span>
              <span v-else>{{ v.status_text }}</span>
              <span>下單總積分：{{ v.money }}</span>
            </div>

            <!-- ✅ 2) 已結算：顯示「結算積分」（盈虧） -->
            <div class="time" v-if="v.opened">
              <span>
                結算積分：
                <span class="delta" :class="{ pos: Number(v.settle_delta) > 0, neg: Number(v.settle_delta) < 0 }">
                  {{ formatSigned(v.settle_delta) }}
                </span>
              </span>
            </div>

            <div class="time">
              <span>下單時間：{{ v.create_time }}</span>
            </div>
            <div class="time">
              <span>結算時間：{{ v.update_time }}</span>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,      // van-pull-refresh 的狀態
      list: [],

      // ✅ 新增：避免重複請求 + 首次載入顯示控制
      isFetching: false,
      isFirstLoading: true,

      // ✅ 載入文案（3秒後會變）
      loadingText: "載入中…請稍候",

      // ✅ 3秒提示用
      slowTimer: null,
      slowToastShown: false,
    };
  },

  methods: {
    back() {
      return window.history.back();
    },

    // ✅ 避免用戶狂下拉：請求中再次下拉，直接結束，不重複打 API
    onRefresh() {
      if (this.isFetching) {
        this.isLoading = false;
        return;
      }
      this.getUserGameList(true);
    },

    // ✅ 快取 key：簡單安全（可依需要加 token 前綴）
    getCacheKey() {
      // 若你希望每個帳號不同快取，可用 token 做區分：
      // const t = localStorage.getItem("token") || "";
      // return "game_record_cache_v1_" + t.slice(0, 12);
      return "game_record_cache_v1";
    },

    // ✅ 先讀快取：立即顯示上一筆購買記錄，加快體感
    loadCache() {
      try {
        const raw = localStorage.getItem(this.getCacheKey());
        if (!raw) return;
        const obj = JSON.parse(raw);
        if (obj && Array.isArray(obj.list) && obj.list.length) {
          this.list = obj.list;
        }
      } catch (e) {
        return; // ✅ 避免 eslint no-empty，且保持吞錯不影響功能
      }
    },

    // ✅ 寫入快取：避免太大，最多存 50 筆（可依需求調整）
    saveCache(list) {
      try {
        const safeList = Array.isArray(list) ? list.slice(0, 50) : [];
        localStorage.setItem(
          this.getCacheKey(),
          JSON.stringify({ ts: Date.now(), list: safeList })
        );
      } catch (e) {
        return; // ✅ 避免 eslint no-empty
      }
    },

    startSlowHint() {
      this.loadingText = "載入中…請稍候";
      this.slowToastShown = false;

      if (this.slowTimer) clearTimeout(this.slowTimer);
      this.slowTimer = setTimeout(() => {
        if (!this.isFetching) return;

        // ✅ 超過 3 秒才提示
        this.loadingText = "正在努力載入，請稍候";
        if (!this.slowToastShown && this.$toast) {
          this.slowToastShown = true;
          this.$toast("正在努力載入，請稍候");
        }
      }, 3000);
    },

    stopSlowHint() {
      if (this.slowTimer) {
        clearTimeout(this.slowTimer);
        this.slowTimer = null;
      }
      this.loadingText = "載入中…請稍候";
      this.slowToastShown = false;
    },

    calcSize(type) {
  if (type === "one") return "火箭";   // 奇
  if (type === "two") return "飛機";   // 偶
  if (type === "big") return "遊艇";   // 11~18
  if (type === "small") return "跑車"; // 3~10
  return type || "";
},

    /**
     * ✅ 取“每个投注项”的积分：
     * - 优先用后端给的字段：money/amount/bet_money/points/point/num
     * - 若没有，则用整单 v.money 平均拆分显示（最后一项补余数）
     */
    getBetMoney(v, citem, idx) {
      const raw =
        (citem &&
          (citem.money ??
            citem.amount ??
            citem.bet_money ??
            citem.points ??
            citem.point ??
            citem.num)) ??
        "";

      const rawNum = Number(raw);
      if (raw !== "" && Number.isFinite(rawNum)) return raw;

      const total = Number(v && v.money != null ? v.money : 0);
      const arr = Array.isArray(v && v.data) ? v.data : [];
      const len = arr.length;

      if (!Number.isFinite(total) || len <= 0) return "";

      const per = Math.floor((total / len) * 100) / 100;
      if (idx === len - 1) {
        const last = Math.round((total - per * (len - 1)) * 100) / 100;
        return last;
      }
      return per;
    },

    formatPoints(val) {
      if (val === "" || val === null || val === undefined) return "";
      if (typeof val === "string") return val;

      const n = Number(val);
      if (!Number.isFinite(n)) return "";
      if (Number.isInteger(n)) return String(n);
      return n.toFixed(2);
    },

    isOpened(item) {
      const statusOk = Number(item && item.status) === 1;

      const hasOpenCode =
        Array.isArray(item && item.opencode) &&
        item.opencode.length >= 3 &&
        item.opencode[0] !== null &&
        item.opencode[1] !== null &&
        item.opencode[2] !== null &&
        item.opencode[0] !== "" &&
        item.opencode[1] !== "" &&
        item.opencode[2] !== "";

      return statusOk && hasOpenCode;
    },

    calcSettleDelta(item) {
      if (!item) return 0;

      if (Array.isArray(item.data) && item.data.length) {
        let sum = 0;
        let hit = false;
        item.data.forEach((ci) => {
          const iw = Number(ci && ci.is_win);
          const p = Number(ci && ci.profit);
          if (iw === 1 && Number.isFinite(p)) { sum += p; hit = true; }
          if (iw === 2 && Number.isFinite(p)) { sum -= p; hit = true; }
        });
        if (hit) return sum;
      }

      const iw = Number(item.is_win);
      const p = Number(item.profit);

      if (iw === 1) return Number.isFinite(p) ? p : 0;
      if (iw === 2) return Number.isFinite(p) ? -p : 0;
      return 0;
    },

    formatSigned(val) {
      const n = Number(val);
      if (!Number.isFinite(n)) return "0";

      const s = Number.isInteger(n) ? String(Math.trunc(n)) : n.toFixed(2);
      if (n > 0) return "+" + s;
      return s;
    },

    getUserGameList(fromRefresh = false) {
      // ✅ 防重：請求中直接結束（避免重複打 API）
      if (this.isFetching) {
        if (fromRefresh) this.isLoading = false;
        return;
      }

      this.isFetching = true;
      if (fromRefresh) this.isLoading = true;

      // ✅ 首次載入：顯示載入中文字；且超過3秒提示
      this.startSlowHint();

      this.$http({
        method: "get",
        url: "user_get_game_list",
      })
        .then((res) => {
          if (res.code === 200) {
            const clist = Array.isArray(res.data) ? res.data : [];
            const list = [];

            clist.forEach((item) => {
              const opened = this.isOpened(item);

              let size = "";
              let double = "";
              let settle_delta = 0;

              if (opened) {
                const a = Number(item.opencode && item.opencode[0] ? item.opencode[0] : 0);
                const b = Number(item.opencode && item.opencode[1] ? item.opencode[1] : 0);
                const c = Number(item.opencode && item.opencode[2] ? item.opencode[2] : 0);
                const sum = a + b + c;

               size = sum % 2 === 1 ? "火箭" : "飛機";

// 2) 遊艇/跑車：看合計大小（大=遊艇，小=跑車）
if (sum >= 11 && sum <= 18) double = "遊艇";
else if (sum >= 3 && sum <= 10) double = "跑車";
else double = "";


                settle_delta = this.calcSettleDelta(item);
              }

              list.push({
                ...item,
                opened,
                size,
                double,
                settle_delta,
              });
            });

            this.list = list;

            // ✅ 寫快取：下次秒開體感更好
            this.saveCache(list);

            if (fromRefresh && this.$toast) this.$toast("刷新成功");
          } else if (res.code === 401) {
            if (this.$toast) this.$toast(res.msg);
          }
        })
        .catch(() => {
          // ✅ 保持原邏輯：吞錯不影響畫面（仍可顯示快取）
          return;
        })
        .then(() => {
          this.stopSlowHint();

          this.isFetching = false;
          this.isLoading = false;
          this.isFirstLoading = false;
        });
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
      return;
    }

    // ✅ 先讀快取，立即顯示上一筆資料
    this.loadCache();

    // ✅ 再拉最新
    this.getUserGameList(false);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

/* ✅ 載入中提示框 */
.loading-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 60px 0;
  color: #f3c7a2;
}
.loading-text {
  margin-top: 18px;
  font-size: 28px;
  font-weight: 600;
  color: #f3c7a2;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  line-height: 60px;
  color: #f3c7a2;
  border: 1px solid #766350;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #f3c7a2;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
}

.item_list .cover {
  width: 60px;
  height: 60px;
  object-fit: cover;
}

.item_list .period-number {
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #f3c7a2;
}

.item_list .lottery_info {
  display: flex;
}

.recent {
  display: flex;
  align-items: center;
  height: 100px;
}

.kuaisan-ball.left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.ressquareBox {
  background: linear-gradient(#fde3ca, #e7b486);
  color: #333;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  border-radius: 16px;
  margin-left: 20px;
  padding: 13px 40px;
  min-width: 13vw;
  white-space: nowrap;

  display: inline-flex;
  align-items: center;
}

.delta {
  margin-left: 8px;
  font-weight: 800;
}
.delta.pos {
  color: #07c160;
}
.delta.neg {
  color: #ff4d4f;
}
</style>
